import engFlag from "../../resources/images/languages/en.png";
import itFlag from "../../resources/images/languages/it.png";
import {useTranslations} from "../../store/LanguageProvider";
import {Box} from "@mui/material";

const LanguageSelector = (props) => {
    const {currentLang, changeLang} = useTranslations();
    const size = props.size || 30;

    const style = {
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        width: size,
        height: size,
        borderRadius: '50%',
        border: '1px solid white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textTransform: 'uppercase',
        color: 'white',
        transition: 'all ease-out .3s',
        backfaceVisibility: 'hidden',
        cursor: 'pointer',
    }


    return <>
        <Box
            sx={{
                width: size + 2,
                height: size + 2,
                prospective: 1000,
                "&:hover > div": {
                    transform: 'rotateY(180deg)'
                }
            }}
            onClick={() => changeLang(currentLang === 'en' ? 'it' : 'en')}>
            <Box position='relative' sx={{
                    width: '100%',
                    height: '100%',
                    transformStyle: 'preserve-3d',
                    transition: 'transform ease-out .3s'}}>
                <Box
                    position='absolute'
                    right={0}
                    top={0}
                    sx={{
                        ...style,
                        backgroundImage: `url(${currentLang === 'en' ? engFlag : itFlag})`
                }}>
                </Box>
                <Box
                    position='absolute'
                    right={0}
                    top={0}
                    sx={{
                        ...style,
                        transform: "rotateY(180deg)",
                        backgroundImage: `url(${currentLang === 'en' ? itFlag : engFlag})`
                    }}>
                </Box>
            </Box>
        </Box>
    </>
}

export default LanguageSelector;